import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import { useAuth } from '../contexts/AuthContext';
import api from '../api';

export default function Home() {
  const { user, temPermissao } = useAuth();
  // Atas e tarefas só aparecem pra quem tem: uma chamada leve resolve os dois cards.
  const [atas, setAtas] = useState({ pastas: 0, tarefas_abertas: 0 });
  useEffect(() => { api.get('/atas/resumo').then(({ data }) => setAtas(data)).catch(() => {}); }, []);

  // Cards base que todo colaborador vê
  const cards = [
    { to: '/cultura', icone: 'bi-heart-fill', titulo: 'Cultura', descricao: 'O que nos move e nossos valores', visivel: temPermissao('ver_cultura') },
    { to: '/organograma', icone: 'bi-diagram-3-fill', titulo: 'Organograma', descricao: 'Quem é quem no Centrão', visivel: temPermissao('ver_organograma') },
    { to: '/avisos', icone: 'bi-megaphone-fill', titulo: 'Avisos', descricao: 'Comunicados importantes', visivel: temPermissao('ver_avisos') },
    { to: '/documentos', icone: 'bi-journal-text', titulo: 'Documentos', descricao: 'Manuais, POPs e treinamentos', visivel: temPermissao('ver_documentos_proprios') },
    { to: '/academia', icone: 'bi-mortarboard-fill', titulo: 'Academia', descricao: 'Trilhas e treinamentos do seu cargo', visivel: true },
    { to: '/minhas-tarefas', icone: 'bi-check2-square', titulo: 'Minhas tarefas', descricao: `${atas.tarefas_abertas} tarefa(s) de reunião esperando por você`, visivel: atas.tarefas_abertas > 0 },
    { to: '/equipe', icone: 'bi-people-fill', titulo: 'Minha Equipe', descricao: 'Acompanhe seus liderados', visivel: temPermissao('ver_equipe') },
    { to: '/admin', icone: 'bi-gear-fill', titulo: 'Administração', descricao: 'Avisos, conteúdo, colaboradores e cargos', visivel: ['publicar_aviso', 'editar_documento', 'gerir_academia', 'gerir_colaboradores', 'gerir_perfis'].some(c => temPermissao(c)) },
  ];

  return (
    <>
      <Header />
      <main className="home-container">
        <div className="home-saudacao">
          Olá, <span className="nome">{user?.nome}</span> 👋
        </div>
        <div className="home-subtitulo">
          Bem-vindo ao Portal do Colaborador. Escolha por onde começar.
        </div>

        <div className="cards-grid">
          {cards.filter(c => c.visivel).map(c => (
            <Link key={c.to} to={c.to} className="card-acesso">
              <i className={`bi ${c.icone}`}></i>
              <div className="titulo">{c.titulo}</div>
              <div className="descricao">{c.descricao}</div>
            </Link>
          ))}
        </div>
      </main>
    </>
  );
}
